module.exports = __webpack_public_path__ + "img/icon_img36.png";